import script from "./ESearchedPatientCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./ESearchedPatientCard.vue?vue&type=script&setup=true&lang=ts"

import "./ESearchedPatientCard.vue?vue&type=style&index=0&id=2a63f23e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a63f23e"]])

export default __exports__